(() => {
'use strict';
if (!window.FieldStore || typeof views === 'undefined' || window.BagyardPreparation) return;
const F = window.FieldStore;
const L = window.BagyardPreparationLabels || {};
const config = window.BagyardPreparationConfig || {};
const t = key => L[key] || key;
const E = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const icons = {
 note:'<path d="M7 4h17v12M24 25v7H7V4M3 10h8M3 18h8M3 26h8m12-4 8-8 4 4-8 8-6 2z"/>',
 camera:'<path d="M4 11h7l3-5h8l3 5h7v19H4z"/><circle cx="18" cy="20" r="6"/>',
 pot:'<path d="M7 15h22v13a4 4 0 0 1-4 4H11a4 4 0 0 1-4-4ZM3 19h4m22 0h4M5 15h26M14 11h8M15 6V3m6 3V3"/>',
 star:'<path d="m18 3 4.5 9.5 10.5 1.4-7.5 7.3 1.8 10.4L18 26.7l-9.3 4.9 1.8-10.4L3 13.9l10.5-1.4Z"/>'
};
const icon = name => `<svg viewBox="0 0 36 36" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round" aria-hidden="true">${icons[name]}</svg>`;
let draft = '', editing = null;
const notes = () => { const value=F.read('notes',[]);return Array.isArray(value)?value.map(n=>({...n})):[]; };
const status = text => {const el=content.querySelector('[data-free-status]');if(el)el.textContent=text;};
function legacyPlan() {
 const p=F.read('plan',null);
 if(!p || typeof p!=='object')return '';
 const bag=typeof products!=='undefined' ? products[p.bag]?.name : '';
 const lines=[bag, typeof p.memo==='string'?p.memo:''];
 if(Array.isArray(p.checked))for(const key of p.checked){if(L['check_'+key])lines.push('✓ '+t('check_'+key));}
 const hand={right:t('right'),left:t('left')};
 if(hand[p.hand])lines.push(t('hand')+': '+hand[p.hand]);
 if(hand[p.rod])lines.push(t('rod')+': '+hand[p.rod]);
 if(['day','short'].includes(p.trip))lines.push(t('trip')+': '+t('trip_'+p.trip));
 return `<details class="fs-panel by-legacy-note"><summary>${E(t('legacy_title'))}</summary><p class="by-note-text">${E(lines.filter(Boolean).join('\n'))}</p><p class="by-storage-note">${E(t('legacy_hint'))}</p></details>`;
}
function notebook() {
 return `<section class="fs-shell by-free-note"><header class="fs-page-heading"><span class="by-note-icon">${icon('note')}</span><span class="fs-kicker">FREE NOTE</span><h2>${E(t('note_title'))}</h2><p class="fs-lead">${E(t('note_intro'))}</p></header><form id="by-free-note-form" class="fs-panel"><label for="by-free-note-text">${E(t('note_label'))}</label><textarea id="by-free-note-text" rows="5" maxlength="1000" required placeholder="${E(t('note_placeholder'))}">${E(draft)}</textarea><div class="fs-actions"><button type="submit" class="fs-button fs-primary">${E(t(editing?'note_update':'note_save'))}</button>${editing?`<button type="button" class="fs-button" data-free-cancel>${E(t('cancel'))}</button>`:''}</div><p class="by-storage-note">${E(t('note_limits'))}</p></form><p data-free-status role="status" aria-live="polite"></p>${byStorageHint()}<div class="fs-note-list">${notes().map((n,i)=>`<article class="fs-panel"><span class="fs-kicker">${E(n.date)}</span><p class="by-note-text">${E(n.text)}</p><div class="fs-actions"><button class="fs-text-button" data-free-edit="${i}">${E(t('edit'))}</button><button class="fs-text-button" data-free-delete="${i}">${E(t('remove'))}</button></div></article>`).join('')||`<p class="by-note-empty">${E(t('note_empty'))}</p>`}</div>${legacyPlan()}<div class="fs-actions"><button class="fs-button" data-free-copy>${E(t('copy_notes'))}</button><button class="fs-button" data-switch="storage">${E(t('backup'))}</button></div><button class="fs-button" data-visit="workshop">${E(t('back_workshop'))}</button></section>`;
}
function safePhoto(value){try {const u=new URL(value);return u.protocol==='https:' && /(^|\.)(shopify\.com|shopifycdn\.com|lsd-designs\.com)$/.test(u.hostname)?u.href:'';}catch{return '';}}
function one() {
 const source=document.getElementById('by-oneoff-template');
 return source?source.innerHTML:'';
}
function updateEntrances(root) {
 // Retired entrances stay out of every dialog; existing saved records are kept.
 for(const key of ['notebook','packing','talk','notes'])root.querySelectorAll(`[data-switch="${key}"],a[href="#${key}"]`).forEach(b=>b.remove());
 const grid=root.querySelector('.by-door-grid');
 if(grid){
  grid.querySelectorAll('[data-switch="packing"]').forEach(b=>b.remove());
  if(!grid.querySelector('[data-switch="one"]')){
   const b=document.createElement('button');b.className='by-door by-door--one';b.dataset.switch='one';
   const photo=safePhoto(config.image);
   b.innerHTML=`<span class="by-door-visual">${photo?`<img src="${E(photo)}" alt="" loading="lazy" width="480" height="360">`:icon('star')}</span><span class="by-door-copy"><strong>${E(t('one_title'))}</strong><small>${E(t('one_short'))}</small></span><span class="by-door-arrow" aria-hidden="true">↗</span>`;
   grid.append(b);
  }
  const soon=root.querySelector('.by-soon');if(soon)soon.querySelectorAll('span').forEach(el=>{if(el.textContent==='一点もの')el.remove();});
 }
 // Keep all existing THE ONE entrances and their layout; only update their labels.
 root.querySelectorAll('[data-switch="one"],a[href="#one"]').forEach(b=>{
  const heading=b.querySelector('.by-door-copy strong');
  if(heading){heading.textContent=t('one_title');return;}
  const label=b.querySelector('strong')||b.querySelector('span');
  if(label)label.textContent=t('one_title');else b.textContent=t('one_title');
 });
 root.querySelectorAll('[data-k-open]').forEach(b=>{b.setAttribute('aria-label',t('kitchen_open'));});
}
const oldShow=show;
show=function(html){oldShow(html);updateEntrances(content);};
views.notebook=notebook;
views.packing=notebook;
views.one=one;
const oldOpen=openView;
openView=function(key){return oldOpen(key==='packing'?'notebook':key);};
const oldGuide=openGuide;
openGuide=function(){oldGuide();updateEntrances(content);};
document.getElementById('floor-guide').onclick=openGuide;
for(const room of Object.values(sceneDefs))room.spots=(room.spots||[]).filter(spot=>!['notebook','packing','talk','notes'].includes(spot.view));
if(window.BagyardWayfindingLabels)window.BagyardWayfindingLabels.notebook=t('note_title');
for(const room of Object.values(sceneDefs))for(const spot of room.spots||[])if(spot.view==='one')spot.t=t('one_title');
const kitchenPhoto=window.KitchenSeed?.posts?.[0]?.image;
if(kitchenPhoto && sceneDefs.kitchen){
 const kitchenSpots=sceneDefs.kitchen.spots;
 const first=kitchenSpots.find(s=>s.view==='kitchen');
 if(first)first.t=t('kitchen_open');
}
function rerender(){openView('notebook');}
function conflict(){status(t('note_conflict'));}
document.addEventListener('input',e=>{if(e.target.id==='by-free-note-text')draft=e.target.value;});
document.addEventListener('submit',e=>{
 if(e.target.id!=='by-free-note-form')return;
 e.preventDefault();
 const text=e.target.querySelector('textarea').value.trim().slice(0,1000),list=notes();
 if(!text)return;
 if(editing){
  const current=list[editing.index];
  if(!current || current.date!==editing.date || current.text!==editing.text){conflict();return;}
  list[editing.index]={...current,text};
 }else{
  if(list.length>=30){status(t('note_full'));return;}
  list.unshift({date:F.day(),text});
 }
 if(!F.write('notes',list)){status(t('note_failed'));return;}
 draft='';editing=null;rerender();status(t('note_saved'));
});
document.addEventListener('click',async e=>{
 const button=e.target.closest('button');if(!button)return;
 if(button.hasAttribute('data-k-open')){e.preventDefault();openView('kitchen');return;}
 if(button.hasAttribute('data-free-cancel')){draft='';editing=null;rerender();return;}
 if(button.hasAttribute('data-free-edit')){
  if(draft && !confirm(t('replace_draft')))return;
  const index=Number(button.dataset.freeEdit),n=notes()[index];if(!n)return;
  editing={index,...n};draft=n.text;rerender();content.querySelector('textarea')?.focus();return;
 }
 if(button.hasAttribute('data-free-delete')){
  const index=Number(button.dataset.freeDelete),list=notes();if(!list[index] || !confirm(t('delete_confirm')))return;
  if(editing){status(t('finish_edit'));return;}
  list.splice(index,1);if(!F.write('notes',list)){status(t('note_failed'));return;}rerender();status(t('note_deleted'));return;
 }
 if(button.hasAttribute('data-free-copy')){
  const text=notes().map(n=>n.date+'\n'+n.text).join('\n\n');
  if(!text){status(t('note_empty'));return;}
  try{await navigator.clipboard.writeText(text);status(t('copied'));}catch{
   status(t('copy_manual'));const area=document.createElement('textarea');area.readOnly=true;area.value=text;area.setAttribute('aria-label',t('copy_notes'));content.querySelector('[data-free-status]').append(area);area.focus();area.select();
  }
 }
},false);
function route(){const key=location.hash.slice(1);if(key==='one')openView(key);}
window.addEventListener('hashchange',route);
window.BagyardNavigationStates=window.BagyardNavigationStates||{};
window.BagyardNavigationStates.notebook={read:()=>({draft,editing}),restore:value=>{({draft,editing}=value);},mount:()=>{if(content.querySelector('.by-free-note'))content.innerHTML=LSDPort.html('<div class="dialog-body">'+notebook()+'</div>');}};
window.BagyardPreparation={notebook,one,updateEntrances,route};
renderSpots();
updateEntrances(content);
route();
})();
